<template>
    <div>
      <template v-if="easypaisa_dashboard === true">
                    <div class="row mt-3">
                     <h1 class="align-center display-5 ml-2">Easy Paisa Dashboard</h1>
                    <div class="col-md-12 mt-3">
                        <div class="row top-widgets-row">
                            <div class="col-md-4 widgets-col">
                                <div class="payroll-counter-box active-employee">
                                    <div class="top-box">
                                        <span class="title" > <em class="rollover"> {{stats.TotalOnboardedCompanies}} </em> </span>
                                        <p> Onboarded Companies </p>
                                    </div>
                                    <div class="foot-box"></div>
                                </div>
                            </div>
                            <div class="col-md-4 widgets-col">
                                <div class="payroll-counter-box payroll-processed">
                                    <div class="top-box">
                                        <span class="title" > <em class="rollover"> {{stats.TotalTransactionCount}} </em> </span>
                                        <p>Transactions Count </p>
                                    </div>
                                    <div class="foot-box"></div>
                                </div>
                            </div>
                            <div class="col-md-4 widgets-col">
                                <div class="payroll-counter-box last-payroll">
                                    <div class="top-box">
                                        <span class="title" > <em class="rollover"> {{new Intl.NumberFormat().format(stats.TotalTransactionVolume)}} </em> </span>
                                        <p> Transactions Volume </p>
                                    </div>
                                    <div class="foot-box"></div>
                                </div>
                            </div>
                        </div>
                        <div class="mt-5" id="summary" aria-labelledby="summary-tab">
                            <div class="table-holder">
                                <table id="dt-summary" class="table table-responsive-xl" style="width:100%">
                                    <thead class="align-center">
                                    <tr>
                                        <th style="display: none;"></th>
                                        <th>Type</th>
                                        <th>Count</th>
                                        <th>Volume</th>
                                    </tr>
                                    </thead>
                                    <tbody class="align-center">
                                    <tr>
                                        <td>CNIC Payments</td>
                                        <td>{{stats.CnicTransactionCount}}</td>
                                        <td>{{new Intl.NumberFormat().format(stats.CnicTransactionVolume)}}</td>
                                    </tr>
                                    <tr>
                                        <td>Wallet Payments</td>
                                        <td>{{stats.WalletTransactionCount}}</td>
                                        <td>{{new Intl.NumberFormat().format(stats.WalletTransactionVolume)}}</td>
                                    </tr>
                                    <tr>
                                        <td>IBFT Payments</td>
                                        <td>{{stats.IBFTTransactionCount}}</td>
                                        <td>{{new Intl.NumberFormat().format(stats.IBFTTransactionVolume)}}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                      <br>
                      <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label class="label block-label"> From Date </label>
                          <datepicker name="from_date" v-model="from_date" input-class="datepicker" :bootstrap-styling="true" placeholder="From Date"></datepicker>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label class="label block-label"> To Date </label>
                          <datepicker name="to_date" v-model="to_date" input-class="datepicker" :bootstrap-styling="true" placeholder="To Date"></datepicker>
                        </div>
                      </div>
                      </div>
                      <div class=" row ml-2">
                        <div class=" float-left col-10">
                          <div>
                            <button class="btn btn-primary export" @click="exportDetail">Export Detail</button>
                          </div>
                        </div>
                        <div class=" float-right col-1">
                          <button @click="getEPDashboardCompanyData" v-if="!showBtn"  class="btn btn-primary">Submit</button>
                          <button @click="filterTable" v-if="showBtn"  class="btn btn-primary">Submit</button>
                        </div>
                      </div>
                      <div>
                        <br>
                      <div class="row ml-2">
                      <div class="searching float-right mr-2">
                        <input id="customSearch" type="text" class="form-control search" name="" />
                      </div>
                      </div>
                      <div class=" p-2">
                        <table id="dt-table" class="table" style="width:100%">
                          <thead>
                          <tr class="align-centre">
                            <th>Company Name</th>
                            <th>Phone No.</th>
                            <th>Account No.</th>
                            <th>Email ID</th>
                            <th>Cnic Payments Count</th>
                            <th>Cnic Payments Volume</th>
                            <th>Wallet Payments Count</th>
                            <th>Wallet Payments Volume</th>
                            <th>IBFT Payments Count</th>
                            <th>IBFT Payments Volume</th>
                            <th>Onboard Date</th>
                          </tr>
                          </thead>
                        </table>
                      </div>
                      </div>
                    </div>
                </div>
      </template>
      <template v-else-if="easypaisa_dashboard === null"><preLoader></preLoader></template>
      <template v-else-if="easypaisa_dashboard === false">
        <notAllowed></notAllowed>
      </template>
    </div>

</template>

<script>

    var dtTable = null;
    export default {
        data() {
            return {
              easypaisa_dashboard: null,
              totalCompanies:0,
                stats : {},
                data : null,
              from_date : '',
              to_date : '',
              showBtn: false,
                search : false,
                companies : [],
                selected_company_id : '-',
                selected_account_no : '-',
            };
        },
        mounted() {
          this.can('easypaisa_dashboard').then(result => {
            if (result.easypaisa_dashboard) {
              this.easypaisa_dashboard = result.easypaisa_dashboard;
            }
            // this.account_balance = result.vr_balance;
          }).then(result => {
            if(this.easypaisa_dashboard == true){
              this.getEPDashboardData();
              this.getEPDashboardCompanyData();
            }
          });

        },
        methods: {
          filterTable(){
            this.$Progress.start();
            dtTable.draw();
            this.$Progress.finish();
          },
            getEPDashboardData : function () {
                // Calling For Dashboard Data
                axios.get('/api/getEPDashboardData')
                .then(res => {
                    if(res.status == 200){
                        this.stats = res.data.summary;

                    }
                })
                .catch(err => {
                    console.log(err);
                    $('.selectpicker').selectpicker('refresh');
                    this.showAlertBox('error','Error to load data');
                });
            },
          getEPDashboardCompanyData: function(){
            this.$Progress.start();
            var that = this;
            dtTable = $('#dt-table').DataTable({
              sDom: '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
              processing: true,
              serverSide: true,
              pageLength: 10,
              searching :true,
              buttons: [],
              ajax: {
                "url": "api/getEPDashboardCompanyData",
                "data": function (d) {
                  d.from_date = moment(that.from_date).format('YYYY-MM-DD');
                  d.to_date = moment(that.to_date).format('YYYY-MM-DD');
                },
                "headers": window.axios.defaults.headers.common,
                "dataSrc": "records",
              },
              deferRender: true,
              columns: [

                {render: function(data,type,full){
                    if(full.name != null){
                      var to_return = full.name;
                      var $url = '/epdashboard/'+full.id+'/'+full.name;
                      // text-limit-10
                      to_return = '<a class="text-limit " title="'+to_return+'" href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')">'+to_return+'</a>';
                      return to_return;
                      // return full.name;
                      //  return '<router-link to=/espdashboard/>'+full.name+'</router-link>';
                    }else{
                      return "---";
                    }
                  }},
                {render: function(data,type,full){
                    if(full.phone != null){
                      return full.phone;
                    }else{
                      return "---";
                    }
                  }},
                {render: function(data,type,full){
                    if(full.walletID != null){
                      return full.walletID;
                    }else{
                      return "---";
                    }
                  }},
                {render: function(data,type,full){
                    if(full.email != null){
                      return full.email;
                    }else{
                      return "--";
                    }
                  }},
                {render: function(data,type,full){
                    if(full.EASY_PAISA_CNIC_COUNT != null){
                      return full.EASY_PAISA_CNIC_COUNT;
                    }else{
                      return "--";
                    }
                  }},
                {render: function(data,type,full){
                    if(full.EASY_PAISA_CNIC_TOTAL != null){
                      return new Intl.NumberFormat().format(full.EASY_PAISA_CNIC_TOTAL);
                    }else{
                      return "---";
                    }
                  }},
                {render: function(data,type,full){
                    if(full.EASY_PAISA_WALLET_COUNT != null){
                      return full.EASY_PAISA_WALLET_COUNT;
                    }else{
                      return "--";
                    }
                  }},
                {render: function(data,type,full){
                    if(full.EASY_PAISA_WALLET_TOTAL != null){
                      return new Intl.NumberFormat().format(full.EASY_PAISA_WALLET_TOTAL);
                    }else{
                      return "---";
                    }
                  }},
                {render: function(data,type,full){
                    if(full.IBFT_COUNT != null){
                      return full.IBFT_COUNT;
                    }else{
                      return "--";
                    }
                  }},
                {render: function(data,type,full){
                    if(full.IBFT_TOTAL != null){
                      return new Intl.NumberFormat().format(full.IBFT_TOTAL);
                    }else{
                      return "---";
                    }
                  }},
                {render: function(data,type,full){
                    if(full.on_board_date != null){
                      return full.on_board_date;
                    }else{
                      return "---";
                    }
                  }},
              ],
              "order": [[ 0, "desc" ]],
              "initComplete": (res) => {
                that.hasPer = true;
                that.showBtn = true;
                setTimeout(function(){
                  $('select.selectpicker').selectpicker();
                },300);
                that.$Progress.finish();
              }
            });
            $('#customSearch').on( 'keyup', function () {
              dtTable.search(this.value).draw();
            });
          },
            exportDetail: function(){
                var that = this;
                that.$Progress.start();
                var formData = {
                  'from_date': moment(this.from_date).format('YYYY-MM-DD'),
                  'to_date': moment(this.to_date).format('YYYY-MM-DD'),
                    'companyCount': '',
                }
                axios.post('/api/epDashboardEPOnboardedCompanyListExport', formData,{
                    responseType: 'blob'
                })
                    .then(res => {
                        if(res.status == 200){
                            const url = URL.createObjectURL(new Blob([res.data], {
                                type: 'application/vnd.ms-excel'
                            }))

                            const link = document.createElement('a')
                            link.href = url
                            link.setAttribute('download', 'CompanyListTransactionsDetail.xls')
                            document.body.appendChild(link)
                            link.click()
                            //that.$Progress.finish();
                        }else{
                            //that.$Progress.fail();
                            that.showAlertBox('error','Error to load data');
                        }
                    })
                    .catch(err => {
                        //that.$Progress.fail();
                        that.showAlertBox('error','Error to load data');
                    });
            },

            },

    }
</script>
